
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/Model';
import store from '@/store';

@Options({})
export default class sidePage extends Vue {

}
